import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { useEffect, useState } from "react";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { useI18n } from "i18n";
import { getInviteUrl } from "helpers/urlHelper";
import copy from "copy-to-clipboard";
import { useAppDispatch } from "store/hooks";
import { addSuccessNotification } from "modules/notification/redux/notificationSlice";
import { format } from "helpers/time/format";
import { ICompany } from "modules/company/types";
import LinkedIn from "./assets/linkedin.svg";
import X from "./assets/x.svg";
import Facebook from "./assets/facebook.svg";
import { useStyles } from "./styles";

const ShareIcon = ({ src }: { src: string }) => (
  <img src={src} height={35} style={{ display: "block" }} alt="share" />
);

export interface EventCallToActionProps {
  company?: ICompany | string;
  eventCode?: string;
  eventName?: string;
  startTime?: number;
}

const EventCallToAction = ({
  eventCode,
  eventName,
  startTime,
}: EventCallToActionProps) => {
  const { t } = useI18n(["eventLanding"]);
  const [inviteLink, setInviteLink] = useState("");
  const appDispatch = useAppDispatch();
  const styles = useStyles();

  useEffect(() => {
    setInviteLink(getInviteUrl({ code: eventCode }));
  }, [eventCode]);

  const handleCopyLink = () => {
    copy(inviteLink);
    appDispatch(
      addSuccessNotification({
        message: t("event:copied.link"),
        autoDismiss: 5,
      }),
    );
  };

  return (
    <Container
      flex
      column
      alignItems="flex-start"
      data-testid="landing-call-to-action"
    >
      <Container flex column alignItems="flex-start">
        <Typography variant="h4">{t("event.social.shareEvent")}</Typography>
        <Container
          flex
          justifyContent="space-between"
          top={10}
          style={{
            gap: "20px",
          }}
        >
          <Button
            variant="tertiary"
            color="dark"
            onClick={handleCopyLink}
            size="md"
            contentWrapperClassName={styles.buttonWrapper}
          >
            {t("event.social.copyLink")}
          </Button>
          <Container
            flex
            fullWidth={false}
            justifyContent="space-between"
            style={{
              gap: "20px",
            }}
          >
            <FacebookShareButton
              url={inviteLink}
              quote={
                startTime
                  ? t("event.share", {
                      eventName,
                      startTime: format(startTime, "MM/DD/YYYY"),
                      link: inviteLink,
                    })
                  : ""
              }
            >
              <ShareIcon src={Facebook} />
            </FacebookShareButton>
            <TwitterShareButton url={inviteLink}>
              <ShareIcon src={X} />
            </TwitterShareButton>
            <LinkedinShareButton url={inviteLink}>
              <ShareIcon src={LinkedIn} />
            </LinkedinShareButton>
          </Container>
        </Container>
      </Container>
    </Container>
  );
};

export default EventCallToAction;
